import EventNotFound from '../components/event-not-found';
<template><EventNotFound /></template>
